import { render, staticRenderFns } from "./CourseVideo.vue?vue&type=template&id=77a37bf1&scoped=true&"
import script from "./CourseVideo.vue?vue&type=script&lang=js&"
export * from "./CourseVideo.vue?vue&type=script&lang=js&"
import style0 from "./CourseVideo.vue?vue&type=style&index=0&id=77a37bf1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a37bf1",
  null
  
)

component.options.__file = "CourseVideo.vue"
export default component.exports